import React from "react";
import { Button, Col, Icon, Modal, Row } from "antd";

import stories from "../data/storiesFemaleToMale";
import { observer } from "mobx-react";

const imgs = {
  kanai: {
    a: require("../imgs/stories/kanai/female_to_male/a.no1.jpg"),
    b: require("../imgs/stories/kanai/female_to_male/b.no1.jpg"),
    c: require("../imgs/stories/kanai/female_to_male/c.no1.jpg"),
    d: require("../imgs/stories/kanai/female_to_male/d.no1.jpg"),
    e: require("../imgs/stories/kanai/female_to_male/e.no1.jpg"),
    f: require("../imgs/stories/kanai/female_to_male/f.no1.jpg"),
    g: require("../imgs/stories/kanai/female_to_male/g.no1.jpg"),
    h: require("../imgs/stories/kanai/female_to_male/h.no1.jpg"),
    i: require("../imgs/stories/kanai/female_to_male/i.no1.jpg"),
    j: require("../imgs/stories/kanai/female_to_male/j.no1.jpg"),
    k: require("../imgs/stories/kanai/female_to_male/k.no1.jpg"),
    l: require("../imgs/stories/kanai/female_to_male/l.no1.jpg"),
    m: require("../imgs/stories/kanai/female_to_male/m.no1.jpg"),
    n: require("../imgs/stories/kanai/female_to_male/n.no1.jpg"),
    o: require("../imgs/stories/kanai/female_to_male/o.no1.jpg"),
    p: require("../imgs/stories/kanai/female_to_male/p.no1.jpg"),
    q: require("../imgs/stories/kanai/female_to_male/q.no1.jpg"),
    r: require("../imgs/stories/kanai/female_to_male/r.no1.jpg"),
    s: require("../imgs/stories/kanai/female_to_male/s.no1.jpg"),
    s1: require("../imgs/stories/kanai/female_to_male/s1.no1.jpg"),
    s2: require("../imgs/stories/kanai/female_to_male/s2.no1.jpg"),
    s3: require("../imgs/stories/kanai/female_to_male/s3.no1.jpg"),
    s4: require("../imgs/stories/kanai/female_to_male/s4.no1.jpg"),
    s5: require("../imgs/stories/kanai/female_to_male/s5.no1.jpg"),
    s6: require("../imgs/stories/kanai/female_to_male/s6.no1.jpg"),
    s7: require("../imgs/stories/kanai/female_to_male/s7.no1.jpg"),
    s8: require("../imgs/stories/kanai/female_to_male/s8.no1.jpg"),
    s9: require("../imgs/stories/kanai/female_to_male/s9.no1.jpg"),
    s10: require("../imgs/stories/kanai/female_to_male/s10.no1.jpg"),
    s11: require("../imgs/stories/kanai/female_to_male/s11.no1.jpg"),
    s12: require("../imgs/stories/kanai/female_to_male/s12.no1.jpg"),
    s13: require("../imgs/stories/kanai/female_to_male/s13.no1.jpg"),
    s14: require("../imgs/stories/kanai/female_to_male/s14.no1.jpg"),
    s15: require("../imgs/stories/kanai/female_to_male/s15.no1.jpg"),
    s16: require("../imgs/stories/kanai/female_to_male/s16.no1.jpg"),
    s17: require("../imgs/stories/kanai/female_to_male/s17.no1.jpg"),
    s18: require("../imgs/stories/kanai/female_to_male/s18.no1.jpg"),
    s19: require("../imgs/stories/kanai/female_to_male/s19.no1.jpg"),
    t: require("../imgs/stories/kanai/female_to_male/t.no1.jpg"),
    u: require("../imgs/stories/kanai/female_to_male/u.no1.jpg"),
    v: require("../imgs/stories/kanai/female_to_male/v.no1.jpg"),
    w: require("../imgs/stories/kanai/female_to_male/w.no1.jpg"),
    x: require("../imgs/stories/kanai/female_to_male/x.no1.jpg"),
    y: require("../imgs/stories/kanai/female_to_male/y.no1.jpg"),
    z: require("../imgs/stories/kanai/female_to_male/z.no1.jpg"),
    aa: require("../imgs/stories/kanai/female_to_male/aa.no1.jpg"),
    ab: require("../imgs/stories/kanai/female_to_male/ab.no1.jpg"),
    ac: require("../imgs/stories/kanai/female_to_male/ac.no1.jpg"),
    ad: require("../imgs/stories/kanai/female_to_male/ad.no1.jpg"),
    ae: require("../imgs/stories/kanai/female_to_male/ae.no1.jpg"),
    ai2: require("../imgs/stories/kanai/female_to_male/a.no2.jpg"),
    bi2: require("../imgs/stories/kanai/female_to_male/b.no2.jpg"),
    ci2: require("../imgs/stories/kanai/female_to_male/c.no2.jpg"),
    di2: require("../imgs/stories/kanai/female_to_male/d.no2.jpg"),
    ei2: require("../imgs/stories/kanai/female_to_male/e.no2.jpg"),
    fi2: require("../imgs/stories/kanai/female_to_male/f.no2.jpg"),
    gi2: require("../imgs/stories/kanai/female_to_male/g.no2.jpg"),
    hi2: require("../imgs/stories/kanai/female_to_male/h.no2.jpg"),
    ii2: require("../imgs/stories/kanai/female_to_male/i.no2.jpg"),
    ji2: require("../imgs/stories/kanai/female_to_male/j.no2.jpg"),
    ki2: require("../imgs/stories/kanai/female_to_male/k.no2.jpg"),
    li2: require("../imgs/stories/kanai/female_to_male/l.no2.jpg"),
    mi2: require("../imgs/stories/kanai/female_to_male/m.no2.jpg"),
    ni2: require("../imgs/stories/kanai/female_to_male/n.no2.jpg"),
    oi2: require("../imgs/stories/kanai/female_to_male/o.no2.jpg"),
    pi2: require("../imgs/stories/kanai/female_to_male/p.no2.jpg"),
    qi2: require("../imgs/stories/kanai/female_to_male/q.no2.jpg"),
    ri2: require("../imgs/stories/kanai/female_to_male/r.no2.jpg"),
    si2: require("../imgs/stories/kanai/female_to_male/s.no2.jpg"),
    s1i2: require("../imgs/stories/kanai/female_to_male/s1.no2.jpg"),
    s2i2: require("../imgs/stories/kanai/female_to_male/s2.no2.jpg"),
    s3i2: require("../imgs/stories/kanai/female_to_male/s3.no2.jpg"),
    s4i2: require("../imgs/stories/kanai/female_to_male/s4.no2.jpg"),
    s5i2: require("../imgs/stories/kanai/female_to_male/s5.no2.jpg"),
    s6i2: require("../imgs/stories/kanai/female_to_male/s6.no2.jpg"),
    s7i2: require("../imgs/stories/kanai/female_to_male/s7.no2.jpg"),
    s8i2: require("../imgs/stories/kanai/female_to_male/s8.no2.jpg"),
    s9i2: require("../imgs/stories/kanai/female_to_male/s9.no2.jpg"),
    s10i2: require("../imgs/stories/kanai/female_to_male/s10.no2.jpg"),
    s11i2: require("../imgs/stories/kanai/female_to_male/s11.no2.jpg"),
    s12i2: require("../imgs/stories/kanai/female_to_male/s12.no2.jpg"),
    s13i2: require("../imgs/stories/kanai/female_to_male/s13.no2.jpg"),
    s14i2: require("../imgs/stories/kanai/female_to_male/s14.no2.jpg"),
    s15i2: require("../imgs/stories/kanai/female_to_male/s15.no2.jpg"),
    s16i2: require("../imgs/stories/kanai/female_to_male/s16.no2.jpg"),
    s17i2: require("../imgs/stories/kanai/female_to_male/s17.no2.jpg"),
    s18i2: require("../imgs/stories/kanai/female_to_male/s18.no2.jpg"),
    s19i2: require("../imgs/stories/kanai/female_to_male/s19.no2.jpg"),
    ti2: require("../imgs/stories/kanai/female_to_male/t.no2.jpg"),
    ui2: require("../imgs/stories/kanai/female_to_male/u.no2.jpg"),
    vi2: require("../imgs/stories/kanai/female_to_male/v.no2.jpg"),
    wi2: require("../imgs/stories/kanai/female_to_male/w.no2.jpg"),
    xi2: require("../imgs/stories/kanai/female_to_male/x.no2.jpg"),
    yi2: require("../imgs/stories/kanai/female_to_male/y.no2.jpg"),
    zi2: require("../imgs/stories/kanai/female_to_male/z.no2.jpg"),
    aai2: require("../imgs/stories/kanai/female_to_male/aa.no2.jpg"),
    abi2: require("../imgs/stories/kanai/female_to_male/ab.no2.jpg"),
    aci2: require("../imgs/stories/kanai/female_to_male/ac.no2.jpg"),
    adi2: require("../imgs/stories/kanai/female_to_male/ad.no2.jpg"),
    aei2: require("../imgs/stories/kanai/female_to_male/ae.no2.jpg")
  },
  // nakagawa: {
  //   a: require("../imgs/stories/female_to_male/a.no1.jpg"),
  //   b: require("../imgs/stories/female_to_male/b.no1.jpg"),
  //   c: require("../imgs/stories/female_to_male/c.no1.jpg"),
  //   d: require("../imgs/stories/female_to_male/d.no1.jpg"),
  //   e: require("../imgs/stories/female_to_male/e.no1.jpg"),
  //   f: require("../imgs/stories/female_to_male/f.no1.jpg"),
  //   g: require("../imgs/stories/female_to_male/g.no1.jpg"),
  //   h: require("../imgs/stories/female_to_male/h.no1.jpg"),
  //   i: require("../imgs/stories/female_to_male/i.no1.jpg"),
  //   j: require("../imgs/stories/female_to_male/j.no1.jpg"),
  //   k: require("../imgs/stories/female_to_male/k.no1.jpg"),
  //   l: require("../imgs/stories/female_to_male/l.no1.jpg"),
  //   m: require("../imgs/stories/female_to_male/m.no1.jpg"),
  //   n: require("../imgs/stories/female_to_male/n.no1.jpg"),
  //   o: require("../imgs/stories/female_to_male/o.no1.jpg"),
  //   p: require("../imgs/stories/female_to_male/p.no1.jpg"),
  //   q: require("../imgs/stories/female_to_male/q.no1.jpg"),
  //   r: require("../imgs/stories/female_to_male/r.no1.jpg"),
  //   s: require("../imgs/stories/female_to_male/s.no1.jpg"),
  //   t: require("../imgs/stories/female_to_male/t.no1.jpg"),
  //   u: require("../imgs/stories/female_to_male/u.no1.jpg"),
  //   v: require("../imgs/stories/female_to_male/v.no1.jpg"),
  //   w: require("../imgs/stories/female_to_male/w.no1.jpg"),
  //   x: require("../imgs/stories/female_to_male/x.no1.jpg"),
  //   y: require("../imgs/stories/female_to_male/y.no1.jpg"),
  //   z: require("../imgs/stories/female_to_male/z.no1.jpg"),
  //   aa: require("../imgs/stories/female_to_male/aa.no1.jpg"),
  //   ab: require("../imgs/stories/female_to_male/ab.no1.jpg"),
  //   ac: require("../imgs/stories/female_to_male/ac.no1.jpg"),
  //   ad: require("../imgs/stories/female_to_male/ad.no1.jpg"),
  //   ae: require("../imgs/stories/female_to_male/ae.no1.jpg"),
  //   ai2: require("../imgs/stories/female_to_male/a.no2.jpg"),
  //   bi2: require("../imgs/stories/female_to_male/b.no2.jpg"),
  //   ci2: require("../imgs/stories/female_to_male/c.no2.jpg"),
  //   di2: require("../imgs/stories/female_to_male/d.no2.jpg"),
  //   ei2: require("../imgs/stories/female_to_male/e.no2.jpg"),
  //   fi2: require("../imgs/stories/female_to_male/f.no2.jpg"),
  //   gi2: require("../imgs/stories/female_to_male/g.no2.jpg"),
  //   hi2: require("../imgs/stories/female_to_male/h.no2.jpg"),
  //   ii2: require("../imgs/stories/female_to_male/i.no2.jpg"),
  //   ji2: require("../imgs/stories/female_to_male/j.no2.jpg"),
  //   ki2: require("../imgs/stories/female_to_male/k.no2.jpg"),
  //   li2: require("../imgs/stories/female_to_male/l.no2.jpg"),
  //   mi2: require("../imgs/stories/female_to_male/m.no2.jpg"),
  //   ni2: require("../imgs/stories/female_to_male/n.no2.jpg"),
  //   oi2: require("../imgs/stories/female_to_male/o.no2.jpg"),
  //   pi2: require("../imgs/stories/female_to_male/p.no2.jpg"),
  //   qi2: require("../imgs/stories/female_to_male/q.no2.jpg"),
  //   ri2: require("../imgs/stories/female_to_male/r.no2.jpg"),
  //   si2: require("../imgs/stories/female_to_male/s.no2.jpg"),
  //   s1i2: require("../imgs/stories/female_to_male/s1.no2.jpg"),
  //   s2i2: require("../imgs/stories/female_to_male/s2.no2.jpg"),
  //   s3i2: require("../imgs/stories/female_to_male/s3.no2.jpg"),
  //   s4i2: require("../imgs/stories/female_to_male/s4.no2.jpg"),
  //   s5i2: require("../imgs/stories/female_to_male/s5.no2.jpg"),
  //   s6i2: require("../imgs/stories/female_to_male/s6.no2.jpg"),
  //   s7i2: require("../imgs/stories/female_to_male/s7.no2.jpg"),
  //   s8i2: require("../imgs/stories/female_to_male/s8.no2.jpg"),
  //   s9i2: require("../imgs/stories/female_to_male/s9.no2.jpg"),
  //   s10i2: require("../imgs/stories/female_to_male/s10.no2.jpg"),
  //   s11i2: require("../imgs/stories/female_to_male/s11.no2.jpg"),
  //   s12i2: require("../imgs/stories/female_to_male/s12.no2.jpg"),
  //   s13i2: require("../imgs/stories/female_to_male/s13.no2.jpg"),
  //   s14i2: require("../imgs/stories/female_to_male/s14.no2.jpg"),
  //   s15i2: require("../imgs/stories/female_to_male/s15.no2.jpg"),
  //   s16i2: require("../imgs/stories/female_to_male/s16.no2.jpg"),
  //   s17i2: require("../imgs/stories/female_to_male/s17.no2.jpg"),
  //   s18i2: require("../imgs/stories/female_to_male/s18.no2.jpg"),
  //   s19i2: require("../imgs/stories/female_to_male/s19.no2.jpg"),
  //   ti2: require("../imgs/stories/female_to_male/t.no2.jpg"),
  //   ui2: require("../imgs/stories/female_to_male/u.no2.jpg"),
  //   vi2: require("../imgs/stories/female_to_male/v.no2.jpg"),
  //   wi2: require("../imgs/stories/female_to_male/w.no2.jpg"),
  //   xi2: require("../imgs/stories/female_to_male/x.no2.jpg"),
  //   yi2: require("../imgs/stories/female_to_male/y.no2.jpg"),
  //   zi2: require("../imgs/stories/female_to_male/z.no2.jpg"),
  //   aai2: require("../imgs/stories/female_to_male/aa.no2.jpg"),
  //   abi2: require("../imgs/stories/female_to_male/ab.no2.jpg"),
  //   aci2: require("../imgs/stories/female_to_male/ac.no2.jpg"),
  //   adi2: require("../imgs/stories/female_to_male/ad.no2.jpg"),
  //   aei2: require("../imgs/stories/female_to_male/ae.no2.jpg")
  // }
};

const adapt = (story, book) => {
  // ストーリーの説明文の置き換え
  story = story.replace(/◯◯◯/g, book.receiverName); // 贈る人の名前
  // story = story.replace(/△△△/g, book.childrenToRender);
  // story = story.replace(/◯△◯/g, book.childrenRender);
  // story = story.replace(/△◯△/g, book.children + 1);
  // story = book.children > 0 ?
  //   story :
  //   story.replace(
  //     /、家族みんなでたわいもないことで/g,
  //     `、${book.receiverName}と一緒にたわいもないことで`
  //   );
  return story;
};

const getImg = (book, id, is2Page = false) => {
  const a = book.artistName !== "" ? book.artistName : "kanai",
    withTemplate = `${id}${book.childrenTemplate}${is2Page ? 'i2' : ''}`,
    withoutTemplate = `${id}${is2Page ? 'i2' : ''}`;
  const img = imgs[a][withTemplate] || imgs[a][withoutTemplate];
  return img;
}

const storyLabel = {
  item: {
    a: "1：ちょっと短気",
    b: "2：気を許しすぎ",
    c: "3：イビキ",
    d: "4：優柔不断",
    e: "5：共感力の低さ",
    f: "6：詰めの甘さ",
    g: "7：話を聞いていない",
    h: "8：細かすぎるこだわり",
    i: "9：怒ると無口",
    j: "10：面倒くさがり",
    k: "11：負けず嫌い",
    l: "12：大人気ない",
    m: "13：雑",
    n: "14：マイペース",
    o: "15：気を使いすぎる",
    p: "16：レディーファースト",
    q: "17：頼れる安心感",
    r: "18：感性が似ている",
    s: "19：子煩悩",
    t: "20：挑戦する姿勢",
    u: "21：しっかり者",
    v: "22：人間力の高さ",
    w: "23：楽観主義",
    x: "24：世界が広がる",
    y: "25：気配りができる",
    z: "26：裏表がない",
    aa: "27：モチベーション",
    ab: "28：絶対的なサポーター",
    ac: "29：懐が深い",
    ad: "30：深い家族愛",
    ae: "31：優しさ",
  }
};

const Story = ({ artistName, book, id }) => (
  <div className="story">
    <div
      style={{
        background: "white",
        display: "inline-block",
        marginBottom: "5px",
        padding: "5px 12px"
      }}
    >{`ストーリー ${storyLabel.item[id]}`}</div>
    <div
      className="f-14 lh-24"
      style={{ background: "white", padding: "15px 12px" }}
      dangerouslySetInnerHTML={{ __html: adapt(stories[id], book) }}
    />
    <br />
    <div style={{ overflowX: "scroll" }}>
      <div style={{ width: "180%" }}>
        <img
          style={{ float: "left" }}
          src={getImg(book, id)}
        />
        <img
          style={{ float: "right" }}
          src={getImg(book, id, true)}
        />
      </div>
    </div>
  </div>
);

class StoryList extends React.Component {
  constructor() {
    super();
    this.state = { visible: false };
  }

  handleCancel = e => {
    this.setState({ visible: false });
  };

  handleNext = () => {
    const l = this.props.list;
    this.setState({ current: l[l.indexOf(this.state.current) + 1] });
  };

  handlePrevious = () => {
    const l = this.props.list;
    this.setState({ current: l[l.indexOf(this.state.current) - 1] });
  };

  handleSelect = e => {
    this.props.onSelect(this.state.current);
    this.setState({ visible: false });
  };

  handleShowModal = () => {
    this.setState({ visible: true });
  };

  componentWillMount() {
    this.setState({ current: this.props.selected || this.props.list[0] });
  }

  componentWillReceiveProps(props) {
    this.setState({ current: props.selected || props.list[0] });
  }

  render() {
    const current = this.state.current,
      { artistName, list, storyCounter } = this.props,
      prev = list.indexOf(current) === 0,
      next = list.indexOf(current) === list.length - 1;
    return (
      <div>
        <div className="story-list link" onClick={this.handleShowModal}>
          <Icon
            type={this.props.selected ? "check-circle" : "edit"}
            style={{ float: "left", marginRight: "5px" }}
            theme="outlined"
          />
          {`ストーリー${storyCounter} `}
          <span className="f-12">{"（見開き2ページ分）"}</span>
          <Icon type="right" />
        </div>
        <Modal
          onCancel={this.handleCancel}
          bodyStyle={{ padding: "10px 0px", background: "#F6F4F9" }}
          //style={{ top: 5 }}
          visible={this.state.visible}
          footer={null}
        >
          <Row className="story-list">
            <Col span={1} />
            <Col span={22}>
              <br />
              <br />
              <Story
                artistName={artistName}
                book={this.props.book}
                id={current}
              />
              {"※顔画像はサンプルになります"}
              <br />
              <br />
              <Row className="story-list" type="flex" justify="space-around">
                <Col span={4} onClick={prev ? null : this.handlePrevious}>
                  <Icon
                    style={{
                      color: prev ? "lightgrey" : "#674397",
                      fontSize: 25,
                      float: "left",
                      marginTop: "9px"
                    }}
                    type="left"
                  />
                  <span style={{ top: "11px", position: "relative", userSelect: "none" }}>
                    前へ
                  </span>
                </Col>
                <Col span={16} style={{ width: "170px" }}>
                  <Button
                    disabled={
                      this.props.disabled.indexOf(this.state.current) !== -1
                    }
                    key="submit"
                    type="primary"
                    onClick={this.handleSelect}
                    style={{
                      width: "170px",
                      padding: "10px",
                      height: "auto"
                    }}
                  >
                    {this.props.disabled.indexOf(this.state.current) !== -1
                      ? "選択済み"
                      : "このストーリーを選ぶ"}
                  </Button>
                </Col>
                <Col span={4} onClick={next ? null : this.handleNext}>
                  <span style={{ top: "11px", position: "relative", userSelect: "none" }}>
                    次へ
                  </span>
                  <Icon
                    style={{
                      color: next ? "lightgrey" : "#674397",
                      fontSize: 25,
                      float: "right",
                      marginTop: "9px"
                    }}
                    type="right"
                  />
                </Col>
              </Row>
              <br />
            </Col>
            <Col span={1} />
          </Row>
        </Modal>
      </div>
    );
  }
}

export default observer(StoryList);



// WEBPACK FOOTER //
// ./src/components/StorylistFemaleToMale.js